import type { FunctionComponent, MouseEventHandler } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@trello/nachos/button';
import type { PopoverTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import styles from './PopoverConfirm.less';

export interface PopoverConfirmProps {
  confirmKey: string;
  confirmCallback: MouseEventHandler;
  isDanger?: boolean;
  isLoading?: boolean;
}

export const PopoverConfirm: FunctionComponent<PopoverConfirmProps> = ({
  confirmKey,
  confirmCallback,
  isDanger,
  isLoading,
}) => {
  return (
    <div
      className={styles.confirmContainer}
      data-testid={getTestId<PopoverTestIds>('popover-confirm')}
    >
      <p>
        <FormattedMessage
          id={`confirm.${confirmKey}.text`}
          defaultMessage="Are you sure?"
          description="Confirmation text"
        />
      </p>

      <Button
        appearance={isDanger ? 'danger' : 'primary'}
        autoFocus
        onClick={confirmCallback}
        size="fullwidth"
        testId={getTestId<PopoverTestIds>('popover-confirm-button')}
        isLoading={isLoading}
      >
        <FormattedMessage
          id={`confirm.${confirmKey}.confirm`}
          defaultMessage="Confirm"
          description="Confirmation button text"
        />
      </Button>
    </div>
  );
};
